import React, { useState, useEffect } from "react";
import utils from "./utils";


export default function FaqArea({ parent, id_faq }) {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const complete = (res) => {
    setFaqs(res.data);
    //setFaqs(faq_demo);
  }


  console.log(id_faq)
  const call = { crud: { data: {}, changed: {} }, cfg: { url: 'listFaqById?size=-1', send: { parent, id_faq } }, complete };
  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (id_faq) utils.call(call);
  }, []);

  if (!id_faq) return <></>;

  if (utils.isEmpty(faqs)) return <div
    key="empty_faq"
    style={{
      background: '#fff',
      borderRadius: 8,
      marginBottom: 10,
      padding: 20,
      fontSize: 20,
      textAlign: 'center',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      border: '1px solid #dce6f2',
    }}
  >
    {utils.lng('no_results', 'Nenhum registro encontrado')}
  </div>;


  return (
    <>
      {faqs.map((faq, index) => (
        <div
          key={index}
          style={{
            background: '#fff',
            borderRadius: 8,
            marginBottom: 10,
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            border: '1px solid #dce6f2',
          }}
        >
          <div
            onClick={() => toggle(index)}
            style={{
              cursor: 'pointer',
              padding: '1rem',
              background: '#387dcb',
              borderRadius: 5,
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 22,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {faq.question}
            <span style={{ fontSize: '1.5rem', transform: openIndex === index ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
              ▶
            </span>
          </div>
          {openIndex === index && (
            <div style={{ padding: '1rem', background: '#f4f8fc', color: '#333', fontSize: 20 }}  >
              <div dangerouslySetInnerHTML={{ __html: faq.answer }} />

              {faq.id > 0 && faq.total > 0 && <>
                <FaqArea parent={faq.id} id_faq={id_faq} />
              </>
              }
            </div>
          )}
        </div>
      ))}
    </>
  );
}